import * as React from "react";
import { action, observable } from "mobx";
import { observer, inject } from "mobx-react";
import { ILocalization } from "../../../models/localization";
import SeekerStore from "../../../stores/seekerStore";
import { Language } from "../../../models/profile";
import { LookupValue } from "../../../models/lookup";
import { LookupType, ExperienceType } from "../../../models/enums";
import { IEditLangLocalization } from "../../../models/localization";
import ResumeNavBtns from "../resumeNavBtns";
import CheckBox from "material-ui/Checkbox";
import Select from "material-ui/Select"
import { MenuItem } from "material-ui/Menu";
import { FormControl, FormControlLabel } from "material-ui/Form";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui/Paper";
import FloatingAddBtn from "../../widgets/addBtn";
import * as s from "./language.css";

@inject("store") @observer
export default class LanugageSummary extends React.Component<{ store: SeekerStore, fromResume: boolean }, {}> {

  @observable langs: Array<Language>;
  @observable message: string;
  
  constructor(props: any) {
    super(props);
    this.langs = this.props.store.profileStore.profile.languages;
    this.state = false;
  }
  @action setLanguageId = (lang: Language, id: number): void => {
    lang.langId = id;
    const lookup: LookupValue = this.props.store.localization.getLookup(LookupType.Language).find((lv: LookupValue): boolean => { return lv.order === id });
    lang.lang = lookup ? lookup.value : "";
  }

  @action updateLanguage = (l: Language, p: number, flag: boolean): void => {
    const local: ILocalization = this.props.store.localization.fields;
    this.props.store.profileStore.setProficiency(l, p, flag);
    this.props.store.profileStore.saveLanguages(this.langs);
    this.props.store.viewState.setShowSnackbar(true, local.profile.langUpdated);
  }

  @action deleteLanguage = (l: Language): void => {
    const local: ILocalization = this.props.store.localization.fields;
    this.props.store.profileStore.deleteLanguageFromSummary(l);
    this.props.store.profileStore.saveLanguages(this.langs);
    this.props.store.viewState.setShowSnackbar(true, local.profile.langDeleted);
  }

  render(): JSX.Element {
    const checked: any = { color: "#5B6770" };
    const langLocal: IEditLangLocalization = this.props.store.localization.fields.editLangs;
    const local: ILocalization = this.props.store.localization.fields;
    const langRows: JSX.Element[] = [];
    const deleteIcon: any = { height: "20px", width: "20px", cursor: "pointer" };
    const langIcons: any = { marginLeft: "8px", height: "30px", width: "30px" };

    this.langs.map((l: Language, i: number): void => {
      let incl: boolean = false;
      if (this.props.fromResume) {
        incl = this.props.store.profileStore.languageSelected(l);
      } else {
        incl = l.langId > 0;
      }
      if (l.langId > 0) {
        langRows.push(
          <Row key={i}>
            <Col xs={4} className={s.addColMargin}>{l.lang}</Col>
            <Col xs={2} >
              <CheckBox checked={(l.proficiency & 2) > 0} disabled={!incl} style={checked} onChange={(e: object, chk: boolean) => this.updateLanguage(l, 2, chk)} />
            </Col>
            <Col xs={2}>
              <CheckBox checked={(l.proficiency & 4) > 0} disabled={!incl} style={checked} onChange={(e: object, chk: boolean) => this.updateLanguage(l, 4, chk)} />
            </Col>
            <Col xs={2}>
              <CheckBox checked={(l.proficiency & 8) > 0} disabled={!incl} style={checked} onChange={(e: object, chk: boolean) => this.updateLanguage(l, 8, chk)} />
            </Col>
            <Col xs={2} className={s.addColMargin}>
              {!this.props.fromResume && <div onClick={() => this.deleteLanguage(l)}><img style={deleteIcon} src={local.icons.trash} /></div>}
            </Col>
          </Row>)
      } 
    });

    if (langRows.length === 0) {
      langRows.push(<p key="no-lang-text">{local.profile.languageDefaultMsg}</p>);
    }
    return (
      <Paper elevation={1} className={s.box} >
        <Row className={s.container}>
          <Col xs={12}>
            <h5 className={s.blueHeader}>{local.myLanguages}</h5>
          </Col>
          <Row className={s.row}>
            <Col xs={12} className={s.col}>
              <Row className={s.headers}>
                <Col xs={4}>&nbsp;</Col>
                <Col xs={2}><img style={langIcons} src={local.icons.read} /></Col>
                <Col xs={2}><img style={langIcons} src={local.icons.write} /></Col>
                <Col xs={2}><img style={langIcons} src={local.icons.speak} /></Col>
                <Col xs={2}>{langLocal.include}</Col>
              </Row>
              {langRows}
            </Col>
          </Row>
        </Row>
        <FloatingAddBtn store={this.props.store} value={ExperienceType.Language} n={3}/>
      </Paper>);
  }
}


// WEBPACK FOOTER //
// ./src/components/profile/languageSummary/index.tsx